import { Box } from '@chakra-ui/react'
import { Spinner } from '@missionlabs/react'
import { FC } from 'react'

export const ChatHistoryLoading: FC = () => {
    return (
        <Box
            position="absolute"
            left={0}
            right={0}
            top={0}
            bottom={0}
            w="full"
            h="full"
            bg="white"
            display="flex"
            alignItems="center"
            justifyContent="center"
            zIndex={100}
        >
            <Spinner size="sm" />
        </Box>
    )
}
